import { Time } from '@angular/common';
import { DataFarmType } from './dataFarmType';
import { DataSourceType } from './dataSourceType';
import { ColumnMapDefinitionModel } from '../model/columnMapDefinitionModel';

export interface IDataConnector {
  dataConnectorType: DataConnectorType;
}

export class DataConnector {
  id?: number;
  dataConnectorType: DataConnectorType;
  filePath?: string;
  delimiter?: any;
  sheetName?: any;
  sheets?: any;
  connectionTimeOut: number;
  selectedInstance:string;
  nValue:string;
  databaseType:DatabaseType;
  sqlCommand?:string;
  inputFileNameFileScheduleDirectory?:string;
  baseFileName?:string;
  isUseFtp:boolean=false;
  ftpService: FtpService;
  
  
  constructor(id?: number) {
    this.id = id;
  }
}

enum DatabaseType {
    SQL = 1,
    Oracle,
    MySql,
    Vertica,
    Other
}
export default DatabaseType;

export enum DataConnectorType {
    Database = 1,
    RestApi,
    Text,
    Excel,
    Feather,
    Parquet

}
export enum DataConnectorTypeIngest {
  DataTypeConverter,
  DurationCalc,
  DeduplicateRows,
 GeneralParameters
}
export class ExcelDataConnector extends DataConnector {
  id: number;
  filePath: string;
  fileNameFormat: string;
  sheetName: string;
  sheets: string[];
  connectionTimeOut: number;
  selectedInstance:string;
  nValue:string;

  constructor(id: number, filePath: string, fileNameFormat: string, sheetName: string, sheets: string[], connectionTimeOut: number,selectedInstance: string,nValue: string,isUseFtp:boolean,ftpService:FtpService) {
    super(id);
    this.dataConnectorType = DataConnectorType.Excel;
    this.filePath = filePath;
    this.fileNameFormat = fileNameFormat;
    this.sheetName = sheetName;
    this.sheets = sheets;
    this.connectionTimeOut = connectionTimeOut;
    this.selectedInstance = selectedInstance;
    this.nValue = nValue;
    this.isUseFtp=isUseFtp;
    this.ftpService=ftpService;
  }

  static fromJSON(data: any): ExcelDataConnector {
    //console.log(`fromJson invoked: ${data}`);
    const instance: ExcelDataConnector = Object.assign(new ExcelDataConnector(0, '', '', '', [], 60,'','',false,new FtpService(FtpServerType.SFTP,"","","", 22)), data);
    return instance;
  }
}
export class FileDataConnector extends DataConnector {
  filePath: string;
  fileNameFormat: string;
  delimiter: string;
  connectionTimeOut: number;
  selectedInstance:string;
  nValue:string;


  constructor(id: number, filePath: string, fileNameFormat: string, delimiter: string, connectionTimeOut:number,selectedInstance:string,nValue:string,isUseFtp:boolean,ftpService:FtpService) {
    super(id);
    this.dataConnectorType = DataConnectorType.Text;
    this.filePath = filePath;
    this.fileNameFormat = fileNameFormat;
    this.delimiter = delimiter;
    this.connectionTimeOut = connectionTimeOut;
    this.selectedInstance=selectedInstance;
    this.nValue=nValue;
    this.isUseFtp=isUseFtp;
    this.ftpService=ftpService;
  }

  static fromJSON(data: any): FileDataConnector {
    //console.log(`fromJson invoked: ${data}`);
    const instance: FileDataConnector = Object.assign(new FileDataConnector(0, '', '', '', 60,'','',false,new FtpService(FtpServerType.SFTP,"","","", 22)), data);
    return instance;
  }
}
export class FeatherDataConnector extends DataConnector {
  filePath: string;
  fileNameFormat: string;
  //delimiter: string;
  connectionTimeOut: number;
  selectedInstance:string;
  nValue:string;
  constructor(id: number, filePath: string, fileNameFormat: string, connectionTimeOut:number,selectedInstance:string,nValue:string,isUseFtp:boolean,ftpService:FtpService) {
    super(id);
    this.dataConnectorType = DataConnectorType.Feather;
    this.filePath = filePath;
    this.fileNameFormat = fileNameFormat;
   // this.delimiter = delimiter;
    this.connectionTimeOut = connectionTimeOut;
    this.selectedInstance=selectedInstance;
    this.nValue=nValue;
    this.isUseFtp=isUseFtp;
    this.ftpService=ftpService;
  }

  static fromJSON(data: any): FeatherDataConnector {
    //console.log(`fromJson invoked: ${data}`);
    const instance: FeatherDataConnector = Object.assign(new FeatherDataConnector(0, '', '',  60,'','',false,new FtpService(FtpServerType.SFTP,"","","", 22)), data);
    return instance;
  }
}
export class ParquetDataConnector extends DataConnector {
  filePath: string;
  fileNameFormat: string;
  //delimiter: string;
  connectionTimeOut: number;
  selectedInstance:string;
  nValue:string;
  inputFileNameFileScheduleDirectory:string;
  baseFileName:string;
  isPartitionMode: boolean;
  partitionDirectory: string;
  constructor(id: number, filePath: string, fileNameFormat: string, connectionTimeOut:number,selectedInstance:string,nValue:string,inputFileNameFileScheduleDirectory:string,baseFileName:string,isUseFtp:boolean,ftpService:FtpService,isPartitionMode:boolean=false,partitionDirectory:string='') {
    super(id);
    this.dataConnectorType = DataConnectorType.Parquet;
    this.filePath = filePath;
    this.fileNameFormat = fileNameFormat;
   // this.delimiter = delimiter;
    this.connectionTimeOut = connectionTimeOut;
    this.selectedInstance=selectedInstance;
    this.nValue=nValue;
    this.inputFileNameFileScheduleDirectory=inputFileNameFileScheduleDirectory;
    this.baseFileName=baseFileName
    this.isUseFtp=isUseFtp;
    this.ftpService=ftpService;
    this.isPartitionMode=isPartitionMode;
    this.partitionDirectory=partitionDirectory;
  }

  static fromJSON(data: any): ParquetDataConnector {
    //console.log(`fromJson invoked: ${data}`);
    const instance: ParquetDataConnector = Object.assign(new ParquetDataConnector(0, '', '',  60,'','','','',false,new FtpService(FtpServerType.SFTP,"","","", 22)), data);
    return instance;
  }
}
export class DatabaseConnector extends DataConnector {
  databaseType: DatabaseType;
  databaseServer: string;
  databaseName: string;
  userName?: string;
  password?: string;
  sqlCommand: string;
  connectionTimeOut:number;
  isIntegratedSecurity: boolean;
  dataSourceType: DataSourceType;
  beginDateRange?: Date;
  endDateRange?: Date;
  portNumber?: number;
  driver?: string;
  beginTime?: string;
  endTime?: string;
  timestampField?: string;
  sampleStart?: number;
  sampleEnd?: number;
  tableName?: string;
  sqlCodeExtention?: string;

  constructor(id: number, databaseType: number, databaseServer: string, databaseName: string, sqlCommand: string,connectionTimeOut:number, isIntegratedSecurity: boolean,dataSourceType: number, userName?: string, password?: string, beginDateRange?: Date,endDateRange?: Date,portNumber?: number,driver?: string,beginTime?: string,endTime?: string,timestampField?: string,sampleStart?: number,sampleEnd?: number, tableName?: string, sqlCodeExtention?: string) {
    super(id);
    this.databaseType = databaseType;
    this.databaseServer = databaseServer;
    this.databaseName = databaseName;
    this.userName = userName;
    this.password = password;
    this.sqlCommand = sqlCommand;
    this.connectionTimeOut=connectionTimeOut;
    this.isIntegratedSecurity = isIntegratedSecurity;
    this.dataSourceType = dataSourceType;
    this.dataConnectorType = DataConnectorType.Database;
    this.beginDateRange = beginDateRange;
    this.endDateRange = endDateRange;
    this.portNumber = portNumber;
    this.driver = driver;
    this.beginTime=beginTime;
    this.endTime=endTime;
    this.timestampField=timestampField;
    this.sampleStart=sampleStart;
    this.sampleEnd=sampleEnd;
    this.tableName=tableName;
    this.sqlCodeExtention=sqlCodeExtention;
  }
  static fromJSON(data: any): DatabaseConnector {
    //console.log(`fromJson invoked: ${data}`);
    const instance: DatabaseConnector = Object.assign(new DatabaseConnector(0, 0, '', '', '',0,false,0, '', '',null,null,null,'',null,null,'',null,null), data);
    return instance;
  }
}
export class OracleDataConnector extends DataConnector {
  databaseType: DatabaseType;
  databaseServer: string;
  databaseName: string;
  userName?: string;
  password?: string;
  sqlCommand: string;
  connectionTimeOut:number;
  isIntegratedSecurity: boolean;
  dataSourceType: DataSourceType;
  beginDateRange?: Date;
  endDateRange?: Date;
  portNumber?: number;
  driver?: string;
  beginTime?: string;
  endTime?: string;
  timestampField?: string;
  sampleStart?: number;
  sampleEnd?: number;
  tableName?: string;
  sqlCodeExtention?: string;

  constructor(id: number, databaseType: number, databaseServer: string, databaseName: string, sqlCommand: string,connectionTimeOut:number, isIntegratedSecurity: boolean,dataSourceType: number, userName?: string, password?: string, beginDateRange?: Date,endDateRange?: Date,portNumber?: number,driver?: string,beginTime?: string,endTime?: string,timestampField?: string,sampleStart?: number,sampleEnd?: number, tableName?: string, sqlCodeExtention?: string) {
    super(id);
    this.databaseType = databaseType;
    this.databaseServer = databaseServer;
    this.databaseName = databaseName;
    this.userName = userName;
    this.password = password;
    this.sqlCommand = sqlCommand;
    this.connectionTimeOut=connectionTimeOut;
    this.isIntegratedSecurity = isIntegratedSecurity;
    this.dataSourceType = dataSourceType;
    this.dataConnectorType = DataConnectorType.Database;
    this.beginDateRange = beginDateRange;
    this.endDateRange = endDateRange;
    this.portNumber = portNumber;
    this.driver = driver;
    this.beginTime=beginTime;
    this.endTime=endTime;
    this.timestampField=timestampField;
    this.sampleStart=sampleStart;
    this.sampleEnd=sampleEnd;
    this.tableName=tableName;
    this.sqlCodeExtention=sqlCodeExtention;
  }
  static fromJSON(data: any): OracleDataConnector {
    //console.log(`fromJson invoked: ${data}`);
    const instance: OracleDataConnector = Object.assign(new OracleDataConnector(0, 0, '', '', '',0,false,0, '', '',null,null,null,'',null,null,'',null,null), data);
    return instance;
  }
}
export class VerticaDataConnector extends DataConnector {
  databaseType: DatabaseType;
  databaseServer: string;
  databaseName: string;
  userName?: string;
  password?: string;
  sqlCommand: string;
  connectionTimeOut:number;
  isIntegratedSecurity: boolean;
  dataSourceType: DataSourceType;
  beginDateRange?: Date;
  endDateRange?: Date;
  portNumber?: number;
  driver?: string;
  beginTime?: string;
  endTime?: string;
  timestampField?: string;
  sampleStart?: number;
  sampleEnd?: number;
  tableName?: string;
  sqlCodeExtention?: string;

  constructor(id: number, databaseType: number, databaseServer: string, databaseName: string, sqlCommand: string,connectionTimeOut:number, isIntegratedSecurity: boolean,dataSourceType: number, userName?: string, password?: string, beginDateRange?: Date,endDateRange?: Date,portNumber?: number,driver?: string,beginTime?: string,endTime?: string,timestampField?: string,sampleStart?: number,sampleEnd?: number, tableName?: string, sqlCodeExtention?: string) {
    super(id);
    this.databaseType = databaseType;
    this.databaseServer = databaseServer;
    this.databaseName = databaseName;
    this.userName = userName;
    this.password = password;
    this.sqlCommand = sqlCommand;
    this.connectionTimeOut=connectionTimeOut;
    this.isIntegratedSecurity = isIntegratedSecurity;
    this.dataSourceType = dataSourceType;
    this.dataConnectorType = DataConnectorType.Database;
    this.beginDateRange = beginDateRange;
    this.endDateRange = endDateRange;
    this.portNumber = portNumber;
    this.driver = driver;
    this.beginTime=beginTime;
    this.endTime=endTime;
    this.timestampField=timestampField;
    this.sampleStart=sampleStart;
    this.sampleEnd=sampleEnd;
    this.tableName=tableName;
    this.sqlCodeExtention=sqlCodeExtention;
  }
  static fromJSON(data: any): VerticaDataConnector {
    //console.log(`fromJson invoked: ${data}`);
    const instance: VerticaDataConnector = Object.assign(new VerticaDataConnector(0, 0, '', '', '',0,false,0, '', '',null,null,null,'',null,null,'',null,null), data);
    return instance;
  }
}
export class MySqlDataConnector extends DataConnector {
  databaseType: DatabaseType;
  databaseServer: string;
  databaseName: string;
  userName?: string;
  password?: string;
  sqlCommand: string;
  connectionTimeOut:number;
  isIntegratedSecurity: boolean;
  dataSourceType: DataSourceType;
  beginDateRange?: Date;
  endDateRange?: Date;
  portNumber?: number;
  driver?: string;
  beginTime?: string;
  endTime?: string;
  timestampField?: string;
  sampleStart?: number;
  sampleEnd?: number;
  tableName?: string;
  sqlCodeExtention?: string;

  constructor(id: number, databaseType: number, databaseServer: string, databaseName: string, sqlCommand: string,connectionTimeOut:number, isIntegratedSecurity: boolean,dataSourceType: number, userName?: string, password?: string, beginDateRange?: Date,endDateRange?: Date,portNumber?: number,driver?: string,beginTime?: string,endTime?: string,timestampField?: string,sampleStart?: number,sampleEnd?: number, tableName?: string, sqlCodeExtention?: string) {
    super(id);
    this.databaseType = databaseType;
    this.databaseServer = databaseServer;
    this.databaseName = databaseName;
    this.userName = userName;
    this.password = password;
    this.sqlCommand = sqlCommand;
    this.connectionTimeOut=connectionTimeOut;
    this.isIntegratedSecurity = isIntegratedSecurity;
    this.dataSourceType = dataSourceType;
    this.dataConnectorType = DataConnectorType.Database;
    this.beginDateRange = beginDateRange;
    this.endDateRange = endDateRange;
    this.portNumber = portNumber;
    this.driver = driver;
    this.beginTime=beginTime;
    this.endTime=endTime;
    this.timestampField=timestampField;
    this.sampleStart=sampleStart;
    this.sampleEnd=sampleEnd;
    this.tableName=tableName;
    this.sqlCodeExtention=sqlCodeExtention;
  }
  static fromJSON(data: any): MySqlDataConnector {
    //console.log(`fromJson invoked: ${data}`);
    const instance: MySqlDataConnector = Object.assign(new MySqlDataConnector(0, 0, '', '', '',0,false,0, '', '',null,null,null,'',null,null,'',null,null), data);
    return instance;
  }
}
// Used by server only, Server should be able to accept dataConnectorType but it doesn't
export class FileDataConnectorInfo extends DataConnector {
    filePath: string;
    fileNameFormat: string;
    delimiter: string;
    connectionTimeOut: number;
    selectedInstance:string;
    nValue:string;

    constructor(filePath: string, fileNameFormat: string, delimiter: string, connectionTimeOut:number,selectedInstance:string,nValue:string,isUseFtp:boolean,ftpService:FtpService) {
      super();
      this.dataConnectorType = DataConnectorType.Text;
      this.filePath = filePath;
      this.fileNameFormat = fileNameFormat;
      this.delimiter = delimiter;
      this.connectionTimeOut = connectionTimeOut;
      this.selectedInstance=selectedInstance;
      this.nValue=nValue;
      this.isUseFtp=isUseFtp;
      this.ftpService=ftpService;
    }
}
// Used by server only, Server should be able to accept dataConnectorType feather
export class FeatherDataConnectorInfo extends DataConnector {
  filePath: string;
  fileNameFormat: string;
  connectionTimeOut: number;
  selectedInstance:string;
  nValue:string;

  constructor(filePath: string, fileNameFormat: string,  connectionTimeOut:number,selectedInstance:string,nValue:string,isUseFtp:boolean,ftpService:FtpService) {
    super();
    this.dataConnectorType = DataConnectorType.Feather;
    this.filePath = filePath;
    this.fileNameFormat = fileNameFormat;
    this.connectionTimeOut = connectionTimeOut;
    this.selectedInstance=selectedInstance;
    this.nValue=nValue;
    this.isUseFtp=isUseFtp;
    this.ftpService=ftpService;
  }
}
export class ParaquetDataConnectorInfo extends DataConnector {
  filePath: string;
  fileNameFormat: string;
  connectionTimeOut: number;
  selectedInstance:string;
  nValue:string;
  inputFileNameFileScheduleDirectory:string;
  baseFileName:string;
  isPartitionMode: boolean;
  partitionDirectory: string;

  constructor(filePath: string, fileNameFormat: string,  connectionTimeOut:number,selectedInstance:string,nValue:string,inputFileNameFileScheduleDirectory:string,baseFileName:string,isUseFtp:boolean,ftpService:FtpService,isPartitionMode:boolean=false,partitionDirectory:string='') {
    super();
    this.dataConnectorType = DataConnectorType.Parquet;
    this.filePath = filePath;
    this.fileNameFormat = fileNameFormat;
    this.connectionTimeOut = connectionTimeOut;
    this.selectedInstance=selectedInstance;
    this.nValue=nValue;
    this.inputFileNameFileScheduleDirectory=inputFileNameFileScheduleDirectory
    this.baseFileName=baseFileName
    this.isUseFtp=isUseFtp;
    this.ftpService=ftpService;
    this.isPartitionMode=isPartitionMode;
    this.partitionDirectory=partitionDirectory;
  }
}
export class DatabaseConnectorInfo extends DataConnector {
  databaseType: DatabaseType;
  databaseServer: string;
  databaseName: string;
  userName?: string;
  password?: string;
  sqlCommand: string;
  connectionTimeOut:number;
  beginDateRange?: Date;
  endDateRange?: Date;
  isIntegratedSecurity: boolean;
  portNumber?: number;
  driver?: string;
  beginTime?: string;
  endTime?: string;
  timestampField?: string;
  sampleStart?: number;
  sampleEnd?: number;
  tableName?: string;
  sqlCodeExtention?: string;

  constructor() {
    super();
    this.dataConnectorType = DataConnectorType.Database;
    this.databaseType=DatabaseType.SQL;
  }
}
export class OracleDataConnectorInfo extends DataConnector {
  databaseType: DatabaseType;
  databaseServer: string;
  databaseName: string;
  userName?: string;
  password?: string;
  sqlCommand: string;
  connectionTimeOut: number;
  beginDateRange?: Date;
  endDateRange?: Date;
  isIntegratedSecurity: boolean;
  portNumber?: number;
  driver?: string;
  beginTime?: string;
  endTime?: string;
  timestampField?: string;
  sampleStart?: number;
  sampleEnd?: number;
  tableName?: string;
  sqlCodeExtention?: string;
  serviceName?: string;

  constructor() {
    super();
    this.dataConnectorType = DataConnectorType.Database;
    this.databaseType=DatabaseType.Oracle;
  }
}
export class VerticaDataConnectorInfo extends DataConnector {
  databaseType: DatabaseType;
  databaseServer: string;
  databaseName: string;
  userName?: string;
  password?: string;
  sqlCommand: string;
  connectionTimeOut: number;
  beginDateRange?: Date;
  endDateRange?: Date;
  isIntegratedSecurity: boolean;
  portNumber?: number;
  driver?: string;
  beginTime?: string;
  endTime?: string;
  timestampField?: string;
  sampleStart?: number;
  sampleEnd?: number;
  tableName?: string;
  sqlCodeExtention?: string;
  serviceName?: string;

  constructor() {
    super();
    this.dataConnectorType = DataConnectorType.Database;
    this.databaseType=DatabaseType.Vertica;
  }
}
export class MySqlDataConnectorInfo extends DataConnector {
    databaseType: DatabaseType;
    databaseServer: string;
    databaseName: string;
    userName?: string;
    password?: string;
    sqlCommand: string;
    connectionTimeOut: number;
    beginDateRange?: Date;
    endDateRange?: Date;
    isIntegratedSecurity: boolean;
    portNumber?: number;
    driver?: string;
    beginTime?: string;
    endTime?: string;
    timestampField?: string;
    sampleStart?: number;
    sampleEnd?: number;
    tableName?: string;
    sqlCodeExtention?: string;
    serviceName?: string;
  
    constructor() {
      super();
      this.dataConnectorType = DataConnectorType.Database;
      this.databaseType=DatabaseType.MySql;
    }
}

export class FtpService {
  ftpServerType: FtpServerType;
  ftpServerLocation: string;
  userName: string;
  password: string;
  controlPort: number;

  constructor(ftpServerType: FtpServerType, ftpServerLocation: string, userName: string, password: string, controlPort: number) {
    this.ftpServerType = ftpServerType;
    this.ftpServerLocation = ftpServerLocation;
    this.userName = userName;
    this.password = password;
    this.controlPort = controlPort;
  }

  static fromJSON(data: any): FtpService {
    //console.log(`fromJson invoked: ${data}`);
    const instance: FtpService = Object.assign(new FtpService(FtpServerType.SFTP, '', '', '', 22), data);
    return instance;
  }
}
export enum FtpServerType {
    FTP = 1,
    SFTP=2
}
export class FtpServerTypeUtil {
  static toString(ftpServerType: FtpServerType): string {
      switch (ftpServerType) {
        case FtpServerType.FTP: return 'FTP';
        case FtpServerType.SFTP: return 'SFTP';
      }
  }
}
